import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./containers/App";
import registerServiceWorker from "./registerServiceWorker";
import * as firebase from "firebase";

var config = {
  apiKey: "AIzaSyCABlH5sN-a2CvmGTt75Lswj0pF3KSIA94",
  authDomain: "sh-codesharerealtime.firebaseapp.com",
  databaseURL: "https://sh-codesharerealtime.firebaseio.com",
  projectId: "sh-codesharerealtime",
  storageBucket: "sh-codesharerealtime.appspot.com",
  messagingSenderId: "657802632885"
};

firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js